export default "__VITE_ASSET__drB21IkV__"